import { writable } from 'svelte/store';
export const ModalObject = writable({});


export function showModal(title, body, buttonText){
    let element = document.getElementById("open-modal");
    element.style.visibility = 'visible';
    element.style.opacity = 1;
    element.style.pointerEvents = 'auto'
    ModalObject.set({ isActive : true,  title: title, body: body, buttonText: buttonText});
}

export function hideModal(){
    let element = document.getElementById("open-modal");
        element.style.visibility = 'hidden';
        element.style.opacity = 0;
    setTimeout(() => {
        ModalObject.set({ isActive : false});
        element.style.pointerEvents = 'none'
    }, 250);

    

}